import {TreatmentPlanningDataModel} from './treatment-planning-data.model';

export class TreatmentTabModel {
  tabType: number;
  name: string;
  inNameEditingMode: boolean;
  dataModel: TreatmentPlanningDataModel;
}
